import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["teamResolver", "requestsLoading"];
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import HierarchicalTeamReferenceResolver from 'reference-resolvers/resolvers/HierarchicalTeamReferenceResolver';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isError, isLoading } from 'reference-resolvers/utils';
import { HIERARCHICAL_TEAM
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
} from 'reference-resolvers/constants/ReferenceObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const mapReferenceResolverToPlainJS = resolverInstance => {
  if (isError(resolverInstance) || isLoading(resolverInstance)) {
    return [];
  }
  return resolverInstance.toJS().map(item => item.referencedObject);
};
const WithUsersAndTeamsDataFetching = (Component, resolverOptions = {}) => {
  const DataProvider = _ref => {
    let {
        teamResolver,
        requestsLoading
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      users: [],
      teams: mapReferenceResolverToPlainJS(teamResolver),
      requestsError: isError(teamResolver),
      requestsLoading: requestsLoading || isLoading(teamResolver)
    }));
  };
  const mapResolversToProps = resolvers => {
    return {
      teamResolver: resolvers[HIERARCHICAL_TEAM].all()
    };
  };
  return ProvideReferenceResolvers({
    [HIERARCHICAL_TEAM]: HierarchicalTeamReferenceResolver
  }, ResolveReferences(mapResolversToProps)(DataProvider), resolverOptions);
};
export default WithUsersAndTeamsDataFetching;